import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../../components/Loading/Loading";
import TablePatients from "./TablePatients/TablePatients";
import GroupIcon from "@mui/icons-material/Group";
import { setListPatients } from "../../../../redux/slice/patientsSlice";
import { getAllPatientsOfProvider } from "../../../../services/rest/users/userProviderService";
import ButtonHireMembership from "../../../../components/ButtonHireMembership/ButtonHireMembreship";
import SearchInputEmail from "../../../../components/Dashboard/SearchInput/SearchInputEmail";
import ModalAlert from "../../../../components/ModalAlert/ModalAlert";
import ModalAlertStatusMembership from "../../../../components/ModalAlertStatusMembership/ModalAlertStatusMembership.";
import { getMembershipByUserPS } from "../../../../services/rest/membership/membershipService";
import { setMembership } from "../../../../redux/slice/membershipSlice";
import { getMembershipStatus } from "../../../../hooks/useMembershipExpiration";

function createData(
  _id,
  firstName,
  lastName,
  email,
  phoneNumber,
  membership,
  rol
) {
  return {
    _id,
    firstName,
    lastName,
    email,
    phoneNumber,
    membership,
    rol,
  };
}

const Patients = () => {
  const { listPatients } = useSelector((state) => state.patientsReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { _id, rol, userType, status } = useSelector(
    (state) => state.userReducer
  );
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const nowDate = new Date();
  const auxDate = nowDate.toISOString();

  const dispatch = useDispatch();

  const getListUsers = async () => {
    try {
      setLoading(true);
      const currentMembership = await getMembershipByUserPS({ userId: _id });
      let status = { isExpired: true };

      if (
        currentMembership?.activeMemb?.membershipType &&
        currentMembership?.activeMemb?.membershipType !== "Free"
      ) {
        status = getMembershipStatus(
          currentMembership?.activeMemb?.expiresAt ?? auxDate
        );
      }
      dispatch(
        setMembership({
          _id: currentMembership?.activeMemb?._id ?? 0,
          planName: currentMembership?.activeMemb?.membershipType ?? "Free",
          price: currentMembership?.activeMemb?.amount ?? 0,
          currency: currentMembership?.activeMemb?.currency ?? "MXN",
          description: currentMembership?.description ?? [],
          routeLimit: currentMembership?.routeLimit ?? 0,
          membershipStatus: status?.isExpired ? "inactive" : "active",
          lastPayment: currentMembership?.activeMemb?.paymentDate ?? auxDate,
          nextPayment: currentMembership?.activeMemb?.expiresAt ?? auxDate,
        })
      );
      const formatRows = [];
      //Aqui se hace la peticion a la api de lista de pacientes y se sustituye la variable listPatients por la respuesta de api
      if (membershipStatus !== "active") {
        dispatch(setListPatients({ listPatients: [] }));
        toast.error("Su membresía no esta activa.", 50000);
        setLoading(false);
        return;
      }
      const responseListPatients = await getAllPatientsOfProvider(_id);
      // console.log("Pacientes encontrados", responseListPatients);
      responseListPatients.forEach((patient) => {
        if (patient?.userId) {
          formatRows.push(
            createData(
              patient?.userId ?? 0,
              patient?.firstName ?? "---",
              patient?.lastName ?? "---",
              patient?.email ?? "---",
              patient?.phone ?? 0,
              patient?.membership ?? "---",
              patient?.rol ?? "---"
            )
          );
        }
      });
      // console.log("Pacientes encontrados", formatRows);
      dispatch(setListPatients({ listPatients: formatRows }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("No pudimos obtener los usuarios.  \n Intentelo más tarde.");
    }
  };
  useEffect(() => {
    if (membershipStatus !== "active") {
      setOpen(true);
    }
    getListUsers();
  }, []);
  // console.log("Tipo de usuario", userType);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Loading loading={loading} />
      <ModalAlert open={open} setOpen={setOpen} />
      {status === "active" && <ModalAlertStatusMembership />}
      <Box sx={{ display: "flex", gap: 2 }}>
        <GroupIcon style={{ fontSize: 32 }} />
        <Typography variant="h5">
          Mis {rol === "Coach" ? "corredores" : "pacientes"}
        </Typography>
        {membershipStatus !== "active" && <ButtonHireMembership />}
      </Box>
      <SearchInputEmail
        setFilteredUsers={setFilteredUsers}
        searchEmail={searchEmail}
        setLoading={setLoading}
        setSearchEmail={setSearchEmail}
        filteredUsers={filteredUsers}
        listAllUsers={listPatients}
      />
      <Box>
        {listPatients.length > 0 ? (
          <TablePatients
            rows={
              filteredUsers && filteredUsers.length > 0
                ? filteredUsers
                : listPatients
            }
            setLoading={setLoading}
          />
        ) : (
          <Typography>
            En estos momentos no tienes{" "}
            {rol === "Coach" ? "corredores" : "pacientes"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Patients;
